import React, { useEffect, useState } from "react";
import { api } from "../../../hooks/api";
import { DropdownMultiSelectMenu } from "../../DropdownMenu.tsx";
import { color } from "../../../styles";
import { FilterOption, FilterType } from "../../../../configs/filterTypes";
import { ROLE } from "../../../../data/enums";

interface CategoryGroupsFilterProps {
    onChangeValue: (value: any) => void;
    isReset?: boolean;
    filterType: FilterType;
}

const CategoryGroupsFilter = ({ onChangeValue, isReset, filterType}: CategoryGroupsFilterProps) => {
    const [{ data, isLoading }, fetchCategoryGroups] = api.get(`/products/category-groups/`);
    const [options, setOptions] = useState<FilterOption[]>([]);
    const [selectedItems, setSelectedItems] = useState<FilterOption[]>([]);

    useEffect(() => {
        // Reset options when isReset is true
        if (isReset) {
            onChangeValue([]);
            setSelectedItems([]);
        }
    }, [isReset, onChangeValue]);

    useEffect(() => {
        // Transform category groups data into filter options
        if (data && data.results) {
            const categoryGroupOptions = data.results.map((group: any) => ({
                text: group.name,
                value: group.id,
            }));
            setOptions(categoryGroupOptions);
        }
    }, [data]);

    const handleOnclickItem = (item: FilterOption, isAdded: boolean) => {
        let newSelectedItems: FilterOption[];
        if (isAdded) {
            newSelectedItems = [...selectedItems, item];
        } else {
            newSelectedItems = selectedItems.filter(i => i.value !== item.value);
        }
        setSelectedItems(newSelectedItems);
        console.log('newSelectedItems:', newSelectedItems);
        onChangeValue(newSelectedItems.map(item => item.value));
    };  

    return (
        <DropdownMultiSelectMenu
            menuList={options}
            menuText={filterType.text}
            menuField={filterType.field}
            handleOnclickItem={handleOnclickItem}
            style={{
                height: "30px",
                fontSize: "12px",
                color: color.secondary.DARK_GREY,
            }}
            isReset={isReset}
            dataTestId={filterType.dataTestId}
        />
    );
};

export default CategoryGroupsFilter; 